import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Home, Briefcase, User, Mail } from "lucide-react"; // for icons (npm install lucide-react)

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
  <header className="bg-[#030303] text-white h-6">
      <div className="container mx-auto flex items-center justify-between px-6 py-4 text-white ">
        {/* Logo / Name */}
        {/* Logo / Name */}
        <Link
          to="/"
          className="text-2xl font-bold transition-all duration-300 focus:outline-none"
          style={{ outline: 'none' }}
        >
          <div className="group relative">

            <img src="/Ezeeta Logo.jpg" alt="Ezeeta Logo" className="max-h-28 w-48 transition-transform duration-300" />
            <div className="absolute inset-0 bg-[#030303] mix-blend-overlay pointer-events-none"></div>
          </div>
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-8">
          <Link
            to="/"
            className=" font-medium hover:text-blue-600 transition-all duration-200"
          >
            Home
          </Link>
          <Link
            to="/projects"
            className="font-medium hover:text-blue-600 transition-all duration-200"
          >
            Projects
          </Link>
          <Link
            to="/about"
            className="font-medium hover:text-blue-600 transition-all duration-200"
          >
            About
          </Link>
          <Link
            to="/contact"
            className="font-medium hover:text-blue-600 transition-all duration-200"
          >
            Contact
          </Link>
        </nav>

        {/* Mobile Toggle Button */}
        <button
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
          className="md:hidden hover:text-blue-600 focus:outline-none"
          onClick={toggleMenu}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>
      {/* Mobile Menu Overlay (beautiful) */}
      {isOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={toggleMenu}
            aria-hidden="true"
          />

          {/* Menu panel */}
          <div className="absolute top-20 left-4 right-4">
            <div id="mobile-menu" role="dialog" aria-modal="true" className="bg-white rounded-2xl shadow-2xl overflow-hidden">
              <div className="p-6">
                <nav className="flex flex-col gap-4">
                  <Link
                    to="/"
                    onClick={toggleMenu}
                    className="flex items-center gap-3 text-gray-800 font-semibold px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
                  >
                    <Home size={18} />
                    Home
                  </Link>

                  <Link
                    to="/projects"
                    onClick={toggleMenu}
                    className="flex items-center gap-3 text-gray-800 font-semibold px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
                  >
                    <Briefcase size={18} />
                    Projects
                  </Link>

                  <Link
                    to="/about"
                    onClick={toggleMenu}
                    className="flex items-center gap-3 text-gray-800 font-semibold px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
                  >
                    <User size={18} />
                    About
                  </Link>

                  <Link
                    to="/contact"
                    onClick={toggleMenu}
                    className="flex items-center gap-3 text-gray-800 font-semibold px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
                  >
                    <Mail size={18} />
                    Contact
                  </Link>
                </nav>

                <div className="mt-6 border-t pt-4 flex items-center justify-between">
                  <div className="text-sm text-gray-500">Made with ♥</div>
                  <button onClick={toggleMenu} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-500 transition-colors">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
